import React from "react";
import { FormattedMessage } from "react-intl";

const inputLabel = ({ label, touched, error, customFeedbackLabel }) => {
  if (touched && error) {
    return (
      <div className="invalid-feedback d-block">
        <FormattedMessage id={error} values={{ label }} />
      </div>
    );
  }

  return "";
};

const selectLabel = ({ label, touched, error, customFeedbackLabel }) => {
  if (touched && error) {
    return (
      <div className="invalid-feedback">
        <FormattedMessage id={error} values={{ label }} />
      </div>
    );
  }

  return <div className="feedback">{customFeedbackLabel && <>{customFeedbackLabel}</>}</div>;
};

export function FieldFeedbackLabel({ label, touched, error, type, customFeedbackLabel }) {
  switch (type) {
    case "text":
      return inputLabel({ label, touched, error, customFeedbackLabel });
    case "email":
      return inputLabel({ label, touched, error, customFeedbackLabel });
    case "password":
      return inputLabel({ label, touched, error, customFeedbackLabel });
    default:
      return selectLabel({ label, touched, error, customFeedbackLabel });
  }
}
